import React from 'react';
import { Field, TextInput, Section } from './QuoteFields';
import { inr, fmtDate } from './quoteApi';

export const AdminQuoteExtras = ({ f, set, calc, isAdmin }) => {
  const setOverride = (date, val) => {
    const next = { ...(f.nightly_overrides || {}) };
    if (val === '') delete next[date]; else next[date] = Number(val);
    set({ nightly_overrides: next });
  };
  const times = (
    <div className="grid grid-cols-2 gap-3 mt-3">
      <Field label="Check-in time">
        <TextInput testid="quote-checkin-time" value={f.check_in_time} onChange={(e) => set({ check_in_time: e.target.value })} />
      </Field>
      <Field label="Check-out time">
        <TextInput testid="quote-checkout-time" value={f.check_out_time} onChange={(e) => set({ check_out_time: e.target.value })} />
      </Field>
    </div>
  );
  if (!isAdmin) return <Section title="Arrival & departure">{times}</Section>;
  return (
    <>
      <Section title="Rate overrides" admin>
        {calc?.nightly_rows?.length ? (
          <div className="space-y-2" data-testid="quote-override-list">
            {calc.nightly_rows.map((r, i) => (
              <div key={r.date} className="flex items-center gap-3">
                <span className="text-xs text-[#374151] w-36 flex-shrink-0">Night {i + 1} · {fmtDate(r.date)}</span>
                <TextInput testid={`quote-override-${i}`} type="number" min={0} placeholder={`Auto ${inr(r.auto_amount)}`}
                  value={f.nightly_overrides?.[r.date] ?? ''} onChange={(e) => setOverride(r.date, e.target.value)} />
              </div>
            ))}
            <p className="text-[11px] text-[#6B7280]">Leave blank to use the live rate (incl. 2nd-night discount).</p>
          </div>
        ) : <p className="text-xs text-[#6B7280]">Select villa &amp; dates to override nightly rates.</p>}
        <div className="grid grid-cols-2 gap-3 mt-3">
          <Field label="Special discount (₹)">
            <TextInput testid="quote-special-discount" type="number" min={0} value={f.special_discount || ''} onChange={(e) => set({ special_discount: Number(e.target.value) || 0 })} />
          </Field>
          <Field label="Discount note">
            <TextInput testid="quote-special-discount-note" value={f.special_discount_note || ''} placeholder="Corporate courtesy" onChange={(e) => set({ special_discount_note: e.target.value })} />
          </Field>
        </div>
        {times}
      </Section>
      <Section title="Notes on quote" admin>
        <textarea data-testid="quote-notes" rows={3} value={f.notes || ''} onChange={(e) => set({ notes: e.target.value })}
          placeholder="e.g. Arrival by bus at 12:30 PM. Caterer to be arranged by client."
          className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#F57C20]" />
      </Section>
    </>
  );
};

export default AdminQuoteExtras;
